<template>
      <div>
        <v-card>
          <v-card-title>
            <span class="headline">{{label}}</span>
          </v-card-title>

          <v-stepper 
          v-model="e1"
          :vertical="false"
          >                
            <v-stepper-header>
              <template v-for="n in steps">
                <v-stepper-step
                  :key="`${n}-step`"
                  :complete="e1 > n"
                  :step="n"
                >
                  Step {{ n }}
                </v-stepper-step>
    
                <v-divider
                  v-if="n !== steps"
                  :key="n"
                ></v-divider>
              </template>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content
                v-for="n in steps"
                :key="`${n}-content`"
                :step="n"
                class="test"
              >
              <v-container>
              <div class="scrollable-div">
                <!-- STEP 1, BASIC DETAILS + IMAGE UPLOAD -->
                  <v-container v-if="n === 1">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field 
                        label="Title*" required
                        :counter="treatmentRules.title.max"
                        :rules="titleRules"
                        v-model="treatment.title"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu
                          v-model="dateMenu"
                          :close-on-content-click="false"
                          max-width="290"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="computedDateFormatted"
                              clearable
                              label="Date Completed"
                              readonly
                              v-on="on"
                              @click:clear="date = null"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="treatment.dateAdded"
                            @change="dateMenu = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="12">
                        <category-control 
                        :parentSelectMode="true" 
                        @valueChanged="categoryChanged($event)"></category-control>
                      </v-col>
                      <v-col cols="12">
                          <v-textarea
                              solo
                              name="description"
                              label="Description"
                              :counter="treatmentRules.description.max"
                              :rules="descriptionRules"
                              v-model="treatment.description"
                          ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-file-input
                        accept="image/png, image/jpeg, image/bmp"
                        chips 
                        multiple 
                        show-size
                        counter
                        prepend-icon="mdi-camera"
                        label="Upload Treatment Images..."
                        v-model="imagesSelected"></v-file-input>
                      </v-col>
                    </v-row>
                  </v-container>

                  <!-- STEP 2, EXTRA NOTES, MEDICAL HISTORY (Patient Details) AND MEDICATION -->
                  <v-container v-if="n === 2">
                  <v-row>
                  <v-col cols="12">
                    <v-expansion-panels accordion>
                      <v-expansion-panel>
                        <v-expansion-panel-header>Patient Details</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row>
                              <v-col cols="12" sm="6">
                                <v-text-field v-model="treatment.patient.age" :rules="ageRules" label="Age"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-select v-model="treatment.patient.gender" label="Gender" :items="['Male','Female']" solo></v-select>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-select :disabled="treatment.patient.age < 18" v-model="treatment.patient.type" label="Type" :items="patientTypes" solo></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-textarea
                                  v-model="treatment.patient.history"
                                  solo
                                  flat
                                  :rules="historyRules"
                                  name="Medical History"
                                  label="Does the patient have any important medical history?"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      v-model="treatmentNotesFormatted"
                      solo
                      :rules="notesRules"
                      name="notes"
                      label="Other Notes"
                    ></v-textarea>
                  </v-col>         

                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Medications</v-card-title>
                      <v-row class="ma-1">
                        <v-col cols="12" sm="2" md="2">
                          <v-text-field
                          v-model="medicationAdding.dosage" label="Dosage"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5" md="5">
                          <v-text-field v-model="medicationAdding.name" label="Search Medication"></v-text-field>
                        </v-col>    
                        <v-col cols="12" sm="3" md="3">
                          <v-select v-model="medicationAdding.reason" label="Reason" :items="['Prescribed','Administered']" solo></v-select>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-btn icon @click="addLinkedMed()"><v-icon>mdi-plus-box</v-icon></v-btn>
                        </v-col>    
                      </v-row>

                      <v-data-table
                        :headers="[{text: 'Dosage', value: 'dosage'}, {text: 'Name', value: 'name'}, {text: 'Reason', value: 'reason'}]"
                        :items="treatment.linkedMeds"
                        sort-by="name"
                        class="elevation-1"
                        hide-default-footer
                        dense
                      >
                      </v-data-table>
                      </v-card>
                  </v-col>       
                </v-row>
              </v-container>

              <!-- STEP 3, TREATMENT PLAN? Now can be referred to as a case -> This may be implemented to create a case from a treatment in the future -->
              <v-container v-if="n === 3">
                  <v-col cols="12" sm="6">
                    <!-- <v-checkbox 
                    v-model="treatmentPlan"
                    label="Is this part of a treatment plan?"
                    @change="treatmentPlanChanged()"></v-checkbox> -->
                  </v-col>

                  <v-col cols="12">
                    <!-- <v-card v-if="Object.keys(currentSelectedPredecessor).length !== 0" outlined> 
                      <v-card-title class="headline">Selected Treatment: {{currentSelectedPredecessor.title}}</v-card-title>
                      <v-card-subtitle>By: {{currentSelectedPredecessor.ownerName}}</v-card-subtitle>
                      <v-card-text>{{currentSelectedPredecessor.description}}</v-card-text>
                      <v-avatar
                        class="ma-3"
                        size="125"
                        tile
                      >
                        <v-img :src="currentSelectedPredecessor.previewImage"></v-img>
                      </v-avatar>
                    </v-card>
                    <quick-treatment-search
                    v-if="treatmentPlan"
                    label="Search for preceding treatment"
                    :orgId="$route.params.userDb.orgid"
                    :uid="$route.params.userDb.uid"
                    :focusEffect="false"
                    type="Treatment Plan"
                    v-on:predecessorEmit="updatePredecessorValue($event)"></quick-treatment-search> -->
                  </v-col>                      
              </v-container>

            <!-- STEPPING BUTTONS -->
                <v-col cols="12">
                  <v-btn 
                  v-show="n !== 1" 
                  text 
                  @click="prevStep(n)">Back</v-btn>

                  <v-btn
                    v-show="n !== steps"
                    color="primary"
                    @click="nextStep(n)"
                  >Continue</v-btn>             
                </v-col>      
                </div>        
              </v-container>        
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>

        <v-card flat>
            <v-card-text>
              <v-row justify="space-between" no-gutters>
                <v-col cols="12" md="4">
                  <small>*Indicates required field</small>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-checkbox label="I have read and accepted the terms and conditions" v-model="termsAccepted">
                      <template v-slot:label>
                        <div>
                          I have read and accepted
                            <a
                              color="primary"
                              @click.stop="tcDialog=true"
                            >
                              Terms and Conditions
                            </a>
                        </div>
                      </template>
                    </v-checkbox>
                    <v-dialog v-model="tcDialog"  persisitent width="600px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Treatment Terms and Conditions</span>
                        </v-card-title>
                        <v-card-text v-text="termsConditions"></v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text @click="disagreeTerms()">Disagree</v-btn>
                          <v-btn color="primary" text @click="agreeTerms()">Agree</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
        </v-card>
          <v-card-actions>
            <v-switch v-model="treatment.public" inset label="Public?" class="pl-4"></v-switch>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="cancelTreatment()">Cancel</v-btn>
            <v-btn color="primary" text @click="saveTreatment()">Save Treatment</v-btn>
          </v-card-actions>
      </v-card>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import firebase from '@/fb'; 
import 'firebase/storage'; //Need to explicitly call cloud storage reference as well
import Treatment from './../treatment.js';
import TreatmentRules from './../config/treatmentRules';
import TermsConditions from './../../../termsconditions';
import moment from 'moment';
import CategoryControl from './../Category/CategoryControl.vue'
import Activity from './../../Management/ActivityTracker/activity.js'
import Toast from './../../../plugins/customToast.js';

export default {
    name: 'addTreatmentPopup',
    components: {
      CategoryControl
    },
    props: {
      label: String,
      editMode: Boolean,
      originalTreatment: Object
    },
    methods: {      
      nextStep (n) {
        if (n === this.steps) {
          this.e1 = 1
        } else {
          this.e1 = n + 1
        }
      },
      prevStep (n) {
        if (n === 1) {
          this.e1 = 1
        } else {
          this.e1 = n - 1
        }
      },
      categoryChanged(categoriesSelected){
        this.treatment.category = categoriesSelected;
      },
      async saveTreatment(){
        var that = this;

        //If this is in edit mode
        if (!this.editMode){
           //If not edit mode add in the user info (This may need to be cleaned up in the future pushed into a function?)
          this.treatment.organisation = this.$route.params.orgDb.id;
          this.treatment.ownerName = this.$route.params.userDb.displayname;
          this.treatment.owner = this.$route.params.userDb.uid;
        }
          //Set dateAdded format + lastModified to now
          this.treatment.dateAdded = moment(this.treatment.dateAdded).format('MM-DD-YYYY hh:mm A');
          this.treatment.dateAddedTimestamp = moment(this.treatment.dateAdded).unix();
          this.treatment.lastModified = moment(new Date()).format('MM-DD-YYYY hh:mm A');
          this.treatment.dateAddedTimestamp = moment(new Date()).unix();
          //Whether it has been edited or not, build a new tags list from what is included in the notes
          this.treatment.buildTagsList();

        //The form entry should always be validated before calling this, error alert will be produced from the validation
        var valid;

        //Check that the terms and conditions have been accepted
        if (this.termsAccepted) {
          valid = await this.treatment.validateTreatment(this.treatmentRules, this.imagesSelected, this.$route.params.userDb.uid)
        } else {
          //If they weren't accepted, push an error
          valid = {result: false, errorMessage: "You must read and accept the terms and conditions to add a treatment"}
        }
        
        if (valid !== true){
          //If the validation is rejected, show the usual Sweet Alert errors
          swal.fire({title: `Error adding to the database`, text: `Your treatment had the following issues: \n${valid.errorMessage}`, icon: "error", showConfirmButton: true, confirmButtonText: "Got it!"})
        } else {
          var addReference;
          
          if (this.editMode){
            addReference = firebase.db.collection('treatments').doc(this.originalTreatment.id).update(JSON.parse(JSON.stringify(this.treatment)));
          } else {
            addReference = firebase.db.collection('treatments').add(JSON.parse(JSON.stringify(this.treatment)));
          }

          addReference
          .then(async function(treatmentRef) {            
            //Depending on the add reference, we need our current documents Id:
            var treatmentId = null;

            if (that.editMode) {
              treatmentId = that.originalTreatment.id;
            } else {
              treatmentId = treatmentRef.id;
            }

            //If Images have been added, then save to storage with the id associated to the treatment:
            if (that.imagesSelected.length > 0){
              var imageStorageRef = that.storageRef.child(`images/treatments/${treatmentId}/`)
              const saved = await that.prepareAndSaveImages(imageStorageRef);
              if (saved){
                that.updateTreatment(treatmentId, that.treatment.images);
              } else {
                //Must have failed updating, fix this handling chain to work a little better
              }
            }

            if (that.editMode){
              //Push the activity to the tracker
              that.activity = new Activity("Edited", {type: "Treatment", id: treatmentId}, moment(new Date()).format('MM-DD-YYYY hh:mm A'));
              that.activity.pushActivityToFirebase(that.$route.params.userDb.uid);
              swal.fire({title: `Successfully Edited Treatment!`, text: `${that.treatment.title} was edited in your organisations treatments list`, icon: "success", showConfirmButton: false});
            } else {
              //Push the activity to the tracker
              that.activity = new Activity("Created", {type: "Treatment", id: treatmentId}, moment(new Date()).format('MM-DD-YYYY hh:mm A'));
              that.activity.pushActivityToFirebase(that.$route.params.userDb.uid);
              swal.fire({title: `Successfully Saved Treatment!`, text: `${that.treatment.title} was saved to your organisations treatments list`, icon: "success", showConfirmButton: false});
            }
          
            that.closeDialog();
          })
          .catch(function(error) {
            swal.fire({title: `Error adding to the database`, text: "Error: " + error, icon: "error", showConfirmButton: false});
          });
        }
      },
      cancelTreatment(){
        this.closeDialog();
      },
      dialogShown(){
        if (this.editMode && this.originalTreatment !== null){
          var oTreatment = this.originalTreatment;
          //If it is the editing, set the current treatment to the one that was propped in
          this.treatment = new Treatment(oTreatment.data.title, oTreatment.data.description, oTreatment.data.comments, oTreatment.data.dateAdded, oTreatment.data.dateAddedTimestamp, oTreatment.data.lastModified, oTreatment.data.lastModifiedTimestamp, oTreatment.data.patient, oTreatment.data.images, oTreatment.data.linkedMeds, oTreatment.data.category, oTreatment.data.notes, oTreatment.data.tags, oTreatment.data.organisation, oTreatment.data.case, oTreatment.data.ownerName, oTreatment.data.owner, oTreatment.data.public, oTreatment.data.upvotes, oTreatment.data.votedBy);
        } else {
          //Otherwise, define it as a new one
          this.resetDialog()
          this.treatment.organisation = this.$route.params.orgDb.id;
          this.treatment.ownerName = this.$route.params.userDb.displayname;
          this.treatment.owner = this.$route.params.userDb.uid;
        }
      },
      async prepareAndSaveImages(currentStorageRef){
        var that = this;
        //PREPARE IMAGES
        const files = this.imagesSelected;

        return new Promise(async function(resolve){

          //LOOP THROUGH EACH IMAGE
          for (var i = 0; i < files.length; i++){
            var file = files[i];
            const filename = file.name;

            var fileStorageRef = currentStorageRef.child(filename);
            if (filename.lastIndexOf(".") <= 0) {
              swal.fire({title: 'Please Add a Valid file!', text: 'Error uploading files', icon: "error", showConfirmButton: false});
              resolve(false);
            } else {
              //SAVE IMAGE TO CLOUD STORAGE
              await fileStorageRef
              .put(file)
              .then(async function() {
                console.log("Successfully Saved Image to Cloud Storage"); // eslint-disable-line no-console
                //Then get the Image URL
                await fileStorageRef
                .getDownloadURL()
                .then(function(imageURL){
                  //Adjust the treatment object to include the download URLs
                  that.treatment.images.push(imageURL);
                  if (i === files.length - 1){
                    //It must be the last loop so resolve this promise, returning 'true' that it has saved
                    resolve(true);
                  }
                });
              })
              .catch(function(error){
                Toast.fire({  icon: 'error',  title: `Storing images failed: ${error}`});
                resolve(false);
              });
            }
          }
        });
      },
      updateTreatment(treatmentId, imageURLs){
        //Create the treatment object to be updated
        var updateObject = {images: imageURLs};

        //Then try to push the downloadURL to the firebase treatment.images array
        firebase.db
        .collection('treatments')
        .doc(treatmentId)
        .update(updateObject)
        .then(function(){
          console.log("Treatment Successfully updated"); // eslint-disable-line no-console
        })
        .catch(function(error){
          console.log("Error updating the image storage references: " + error); // eslint-disable-line no-console
        })
      },
      addLinkedMed(){
        //First validate that the 'addingMedication' object has something in
        if ((this.medicationAdding.name) && (this.medicationAdding.dosage) && (this.medicationAdding.reason)){
          //If so, do the adding to the list
          this.treatment.linkedMeds.push(this.medicationAdding);
          //Then revert the medicationAdding object back to null
          this.medicationAdding = {
            dosage: null,
            name: null,
            reason: null
          }
        } else {
          //If it fails, show a quick notification
          Toast.fire({  icon: 'error',  title: `Attempted medication add is invalid`});
        }
      },
      agreeTerms(){
        this.termsAccepted = true;
        this.tcDialog = false;        
      },
      disagreeTerms(){
        this.termsAccepted = false;
        this.tcDialog = false;
      },
      closeDialog(){
        //This shall emit something to close the dialog and call the reset
        this.resetDialog();

        this.$emit("dialogClosed");
      },
      resetDialog(){
        //Function than can be called on completion, close and load to reset the dialog
        this.imagesSelected = [];

        //Set back to a blank treatment
        this.treatment = new Treatment();
      }
    },
    mounted() {
      this.storageRef = firebase.storage.ref();
    },
    computed: {
        titleRules () {
            const titleRules = [];

            if (this.treatmentRules.title.max) {
              const rule =
              v => (v || '').length <= this.treatmentRules.title.max || `A maximum of ${this.treatmentRules.title.max} characters are allowed` 
              titleRules.push(rule)
            }
            if (this.treatmentRules.title.min) {
              const rule =
              v => (v || '').length >= this.treatmentRules.title.min || `A minimum of ${this.treatmentRules.title.min} characters are required`
              titleRules.push(rule)
            }                           
            return titleRules;
        },
        descriptionRules(){
          const descriptionRules = [];

            if (this.treatmentRules.description.max) {
              const rule =
              v => (v || '').length <= this.treatmentRules.description.max || `A maximum of ${this.treatmentRules.description.max} characters are allowed for the description` 
              descriptionRules.push(rule)
            }
            if (this.treatmentRules.description.min) {
              const rule =
              v => (v || '').length > this.treatmentRules.description.min || `A minimum of ${this.treatmentRules.description.min} characters are required for the description`
              descriptionRules.push(rule)
            }                           
            return descriptionRules;
        },
        historyRules(){
          const historyRules = [];

            if (this.treatmentRules.history.max) {
              const rule =
              v => (v || '').length < this.treatmentRules.history.max || `A maximum of ${this.treatmentRules.history.max} characters are allowed to describe the Medical History` 
              historyRules.push(rule)
            }

          return historyRules;
        },
        ageRules(){
          const ageRules = [];
          
          if (this.treatmentRules.age.max) {
            const rule =
            v => (v || '').length < this.treatmentRules.age.max || `Please enter a valid patient age` 
            ageRules.push(rule)
          }
          return ageRules;
        },
        notesRules(){
          const notesRules = [];

          if (this.treatmentRules.notes.max) {
            const rule =
            v => (v || '').length <= this.treatmentRules.notes.max || `A maximum of ${this.treatmentRules.notes.max} characters are allowed for added notes` 
            notesRules.push(rule)
          }

          return notesRules;
        },
        computedDateFormatted () {
          return this.treatment.dateAdded ? moment(this.treatment.dateAdded).format('dddd, MMMM Do YYYY') : ''
        },
        treatmentNotesFormatted: {
          get() {
            //The get should just take the notes and then with each of the tags on add some extra css formatting
            let wordsList = this.treatment.notes.split(' ');

            wordsList.map(word => {
              if (word.indexOf('#') === 0) {
                //If the word is a tag, replace the word in the wordList with a version of the word but with some inner html around it
                //FOR NOW DO NOTHING//
              }
              return word;
            });
            //Combine the words back together
            let formattedNotes = wordsList.join(" ");

            return formattedNotes
          },
          set(newValue) {
            //Update the full notes value
            this.treatment.notes = newValue;

            //Build the tags list
            this.treatment.buildTagsList();
          }
        },
        patientTypes () {
          if (this.treatment.patient.age < 18) {
            return ['Paediatric'];
          } else {
            return ['Adult', 'Vulnerable Adult']
          }
        }
    },
    watch: {
      steps (val) {
        if (this.e1 > val) {
          this.e1 = val
        }
      },
      originalTreatment: { 
        // the callback will be called immediately after the start of the observation
        immediate: true, 
        handler (val) {
          if (val !== null){
            this.dialogShown();
          }
        }
      },
      'treatment.patient.age': {
        immediate: true,
        handler (val) {
          if (val < 18) {
            this.treatment.patient.type = "Paediatric"
          }
        }
      }
    },
    data: () => ({
        storageRef: "",
        dialog: false,
        e1: 1,
        steps: 3,
        imagesSelected: [],
        treatment: new Treatment(),
        treatmentRules: TreatmentRules,
        dateMenu: false,
        medicationAdding: {
          dosage: null,
          name: null,
          reason: null
        },
        termsAccepted: false,
        tcDialog: false,
        termsConditions: TermsConditions
    })
}
</script>

<style scoped>
.swal-footer {
  background-color: rgb(245, 248, 250);
  margin-top: 32px;
  border-top: 1px solid lightgreen;
  overflow: hidden;
}

.swal-button {
  padding: 2px 5px;
  border-radius: 2px;
  background-color: lightgreen;
  font-size: 12px;
  border: 1px solid lightgreen;
  text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
}

.swal-modal {
  background-color: rgba(63,255,106,0.69);
  border: 3px solid white;
}

.scrollable-div {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow-y: scroll;
}

.test {
  height: 500px;
}
</style>